// extracted by mini-css-extract-plugin
module.exports = {"container":"c1XW3mZwisQszjm6dxiIu","groupsList":"_2_82fe1Ch26rWbQy6LhLoO"};